import {
  mapOrganisationBase,
  OrganisationBase,
} from "@/server/backend-api/organisation";
import { Assert } from "@/utils/assert";
import { ServerRequest } from "../../types";
import { createBackendApiClientWithReq } from "./createBackendApiClient";
import { LinkedId as APILinkedId, AssuranceLevel } from "./generated";

export interface LinkedId {
  homeOrganisation: OrganisationBase;
  isVerified: boolean;
  latestAssuranceLevel: AssuranceLevel | null;
}

function mapLinkedId(apiLinkedId: APILinkedId): LinkedId {
  Assert.check(
    apiLinkedId.homeOrganisation !== null,
    "apiLinkedId.homeOrganisation !== null"
  );
  return {
    ...apiLinkedId,
    homeOrganisation: mapOrganisationBase(apiLinkedId.homeOrganisation),
  };
}

export const getLinkedUniversities = async (
  userRequest: ServerRequest,
  includeUnverified?: boolean
): Promise<LinkedId[]> => {
  const client = createBackendApiClientWithReq(userRequest);
  const ids = await client.profile_GetLinkedIds();
  const mapped = ids.map(mapLinkedId);
  if (includeUnverified) {
    return mapped;
  }
  return mapped.filter((x) => x.isVerified);
};
